import { useMutation } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';

interface TestObservabilityConnectionPayload {
  oneUptimeURL: string;
  apiKey: string;
  projectID: string;
  tlsSkipVerify?: boolean;
  policyId?: number;
  autoRotateKey?: boolean;
}

interface TestObservabilityConnectionResponse {
  success: boolean;
  message?: string;
}

export function useTestObservabilityConnectionMutation() {
  return useMutation({
    mutationFn: testObservabilityConnection,
  });
}

async function testObservabilityConnection(
  payload: TestObservabilityConnectionPayload
): Promise<TestObservabilityConnectionResponse> {
  try {
    const { data } = await axios.post<TestObservabilityConnectionResponse>(
      '/policies/observability-k8s/test',
      payload
    );
    return data;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to test OneUptime connection');
  }
}
